import React from 'react';
import { Cushion, Typography, Rectangle } from '@pitchero/react-ui';
import { Trans } from '../../../lib/i18n';

const ProductUnavailable = () => (
  <Cushion horizontal="medium" vertical="small">
    <Rectangle fill="mercury" radius="rounded">
      <Typography preset="subtitle--small" align="center" component="div">
        <Trans i18nKey="shop:product_unavailable">This product is not available to purchase</Trans>
      </Typography>
    </Rectangle>
  </Cushion>
);

export default ProductUnavailable;
